import axiosInstance from "../../apiAxios/axiosInstance";

export const allactivestaff = async (payload) => {
  const response = await axiosInstance.post("/admin/all-active-staff", payload);
  return response.data;
};
export const PendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/all-newpending-list", payload);
  return response.data;
};
export const assignLeadStore = async (payload) => {
  const response = await axiosInstance.post("/admin/assign-lead-store", payload);
  return response.data;
};

export const getAssignLeadDetails = async (payload) => {
  const response = await axiosInstance.post("/admin/assign-lead-show", payload);
  return response.data;
};

export const reassignLead = (payload) =>
  axiosInstance.post("/admin/relead-assign-store", payload);



export const getStaffDetails = (payload) =>{
  const response=   axiosInstance.post("/admin/staff-show", payload)
  return response
}
 

export const updateStaff = async (data) => {
  const { data: responseData } = await axiosInstance.post(
    "/admin/staff-update",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return responseData;
};

export const deleteStaff = (payload) =>{
  const response=  axiosInstance.post("/admin/staff-delete", payload);
   return response.data
}
 


export const updateStaffStatus = (payload) =>{
 const response=   axiosInstance.post("/admin/staff-status-update", payload)
   return response
}



export const getStaffActivity = () => {
  const response=  axiosInstance.get("/admin/staff-activity-list")
  return response
};
export const viewStaffActivity = (payload) => {

   const resposne=  axiosInstance.post("/admin/staff-activity-view",payload)

 return resposne
};
